var React = require('react');

function CheckEmail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M12.168.608l35.365 7.517c2.645.562 4.345 3.234 3.765 5.96l-5.594 26.317c-.58 2.728-3.205 4.48-5.864 3.914L4.475 36.8C1.83 36.237.13 33.565.71 30.84L6.303 4.521C6.883 1.794 9.51.042 12.168.608zm-2.3 2.95L3.92 31.535c-.192.902.372 1.787 1.26 1.976l35.351 7.514c.888.189 1.764-.39 1.956-1.293l5.946-27.977L9.868 3.558zm2.843.604l13.992 15.01 18.888-8.02 2.843.603-.38 1.793-22.155 9.408L9.487 5.35l.38-1.792 2.844.604z"}));
}

CheckEmail.defaultProps = {"width":"52","height":"45","viewBox":"0 0 52 45"};

module.exports = CheckEmail;

CheckEmail.default = CheckEmail;



// WEBPACK FOOTER //
// ./src/Assets/Icons/check-email.svg